import { motion } from "framer-motion";
import { scrollToSection } from "@/lib/scroll";

const STATS = [
  { value: "4", label: "core channels to cover" },
  { value: "8 min", label: "give or take, end to end" },
  { value: "0", label: "passwords, ever" },
];

export default function Hero() {
  return (
    <section data-testid="hero" className="grain overflow-hidden bg-navy">
      <div className="mx-auto max-w-6xl px-5 pb-14 pt-32 sm:px-8 sm:pb-20 md:pt-40">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-[11px] font-semibold uppercase tracking-[0.16em] text-pink"
        >
          Smart Marketer Agency // Next step
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.08 }}
          className="mt-5 max-w-3xl text-4xl font-bold leading-[1.05] tracking-[-0.035em] text-white sm:text-5xl lg:text-[58px]"
        >
          Next step:{" "}
          <span className="text-pink">access.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.16 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-white/75 md:text-lg"
        >
          Below you'll find exactly how to give us access to Meta, Google Ads, your email
          platform and your attribution tools — about eight minutes for all of them, no
          passwords. Only need one channel? Jump straight to it below.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.24 }}
          className="mt-8 flex flex-wrap gap-4"
        >
          <button
            data-testid="start-guide-button"
            onClick={() => scrollToSection("#guides")}
            className="rounded-full bg-pink px-8 py-4 text-base font-bold text-white shadow-[0_8px_24px_-6px_rgba(242,0,94,0.45)] transition-all duration-200 hover:bg-pink-dark active:scale-[0.98]"
          >
            Start with Meta
          </button>
          <a
            data-testid="hero-email-pep-button"
            href="mailto:pep@smartmarketer.com"
            className="rounded-full border-2 border-white px-8 py-4 text-base font-bold text-white transition-colors duration-200 hover:bg-white hover:text-navy"
          >
            Questions? Email Pep
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.36 }}
          data-testid="onboarding-progress-bar"
          className="mt-12 grid max-w-xl grid-cols-3 gap-6"
        >
          {STATS.map((stat) => (
            <div key={stat.label} className="border-l border-white/20 pl-4">
              <div className="text-3xl font-black leading-none tracking-[-0.04em] text-white md:text-4xl">
                {stat.value}
              </div>
              <div className="mt-2 text-sm leading-snug text-white/70">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
      <div aria-hidden="true" className="pb-6 text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-white/40">
        Pick the channels you need
      </div>
    </section>
  );
}
